<template lang='pug'>
v-card(class='with-pointer')
  div(@click='$emit("click", deal)')
    v-img(:src='house' :lazy-src='house' :aspect-ratio='16/9' class='grey lighten-4')
      v-layout(slot='placeholder' fill-height align-center justify-center ma-0)
        v-progress-circular(indeterminate color='primary')
    div(class='card-wrap')
      v-card-title(class='card-title pb-2') {{ deal.project_name }}
      v-card-text(class='pt-0')
        div(class='card-row mb-3')
          div(class='caption')
            div {{ deal.object_name }}
            div {{ deal.accomodation_type }}
        div(class='card-row my-1')
          //- Если договор ЖНК, не будем выводить блок
          template(v-if='!deal.is_share')
            div(class='grey--text') Договор
            div(class='font-weight-medium')
              | {{ deal.num }} <br>
              | от &laquo;{{ deal.date | date('D MMM YYYY') }}&raquo;
          div(class='card-row my-1')
            div(class='grey--text') Клиент
            div(class='font-weight-medium') {{ deal.client_name }}
          //- Если договор ЖНК, не будем выводить блок
          div(v-if='!deal.is_share' class='card-row my-1')
            div(class='grey--text') Сумма договора
            div(class='font-weight-medium') {{ deal.price | rubles }}
          div(class='card-row my-1')
            div(class='grey--text') Дата передачи объекта
            div(class='font-weight-medium') {{ deal.date_startup | date }}
          //- Если договор ЖНК, покажем shareInfo
          template(v-if='deal.is_share')
            v-slide-y-transition
              div(v-show='show')
                v-divider(class='my-3')
                div(v-for='(r, i) in deal.share_info' :key='i' class='card-row my-1')
                  div(class='grey--text') {{ r.key }}
                  div(class='font-weight-medium') {{ r.val }}
  v-card-actions(@click='show = !show')
    div(class='pl-2') Информация о договоре
    v-spacer
    v-btn(icon)
      v-icon {{ show ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
</template>

<script>
export default {
  props: ['deal'],

  data: () => ({
    show: false
  }),

  computed: {
    house() {
      return `/houses/${this.deal.progress / 10}.png`;
    }
  }
};
</script>

<style scoped>
.card-title {
  font-size: 18px;
  font-weight: 500;
}
</style>
